/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-03-23 15:07:41
 * @modify date 2020-03-23 15:07:41
 * @desc [description]
 */
import axios from 'axios';

export async function deactivateAccountSelf(accountId) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/self/deactivate/${accountId}`;
  let result = '';
  await axios
    .delete(url)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('deactivate self account java api error', err);
    });
  return result;
}

/* user deactviate delete API
 * to deactivate the user */
export async function deactivateUser(formData) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/deactivate/user`;
  let result = '';
  await axios
    .delete(url, { data: formData })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('deactivate user java api error', err); // eslint-disable-line no-console
    });
  return result;
}
